import { FETCH_CARCATS, FETCH_CARCAT, FETCH_CARS, FETCH_CAR } from '../actions/types';

const initialState = {
    carcats: [],
    carcat: {},
    cars: [],
    car: {}
}

function carsReducer(state = initialState, action) {
    switch (action.type) {
        case FETCH_CARCATS:
            return {
                ...state,
                carcats: action.payload
            };
        case FETCH_CARCAT:
            return {
                ...state,
                carcat: action.payload
            };
        case FETCH_CARS:
            return {
                ...state,
                cars: action.payload
            };
        case FETCH_CAR:
            return {
                ...state,
                car: action.payload
            };
        default:
            return state;
    }
}

export default carsReducer;